import moment from "moment-timezone";

const state = () => ({
  init_date_filter: "",
  end_date_filter: "",
});

const getters = {
  getInitDateFilter(state) {
    return state.init_date_filter;
  },
  getEndDateFilter(state) {
    return state.end_date_filter;
  },
};

const mutations = {
  setInitDateFilter(state, date) {
    state.init_date_filter = date;
  },

  setEndDateFilter(state, date) {
    state.end_date_filter = date;
  },
};

const actions = {
  setInitDateFilter({ commit }, payload) {
    commit(
      "setInitDateFilter",
      moment.tz(payload, "YYYY-MM-DD HH:mm", moment.tz.guess()).utc().format("YYYY-MM-DD HH:mm:ss")
    );
  },

  setEndDateFilter({ commit }, payload) {
    commit(
      "setEndDateFilter",
      moment.tz(payload, "YYYY-MM-DD HH:mm", moment.tz.guess()).utc().format("YYYY-MM-DD HH:mm:ss")
    );
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
